import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';



export const INITIAL_STATE = Immutable({
    isAuthenticated: false,
    guestUser: false,
    error: false,
    errorCode: null,
    loginErrorCode:null,
    loginError:null,
    loginMessage:null,
    message: null,
    isSignup: false,
    isLoading: false,
    userProfile: {
        userId: null,
        fullName: '',
        imageUrl: null,
        email: '',
        phone: '',
        address: '',
        dob: '',
        gender: 'M',
        relationship: '',
        city: '',
        pincode: '',
        state: '',
        country: ''
    },

    emailVerified: false,
    emailStatus: false,
    ckeckEmailStatus: false,

    phoneVerified: false,
    phoneStatus: false,
    checkPhoneStatus: false,

    activationVerified:false,
    checkActivationStatus: false,

    checkValidationResponseType:'',
    isUsedValidationResponseType:false,

    isUpdating: false,
    updateStatus: false,
    updateError: '',

    setPassword: false,
    activationInProgress: false,

    isMagicLinkUsed: false,
    isMagicLinkSuccess: false,
    magicLinkMeta: {},
    isMagicLinkTCApplied: false,
    currentStudentId: null,
    isMagicLinkApplied: false,
    showMagicLinkDialog: false,

    userSignUpStatus: null,

    HSGBannerFlag: false,
    isComponentLoading: false,

    showSideBar:false,

    isInvitationLinkUsed: false,
    isInvitationLinkSuccess: false,
    invitationUserDetails: {},
    invitationUserAssociations: [],
    showInvitationLinkModal: false,
    allowInvitationLinkUpdate: false,
    invitationLinkUpdate: [],
    openUserProfile: false,
    modalType:''
});



const loginUser = (state, action) => {
    const newState = {
        isAuthenticated: false,
        guestUser: false,
        error: false,
        errorCode: null,
        message: null,
        isSignup: false,
        isLoading: true,
        userProfile: INITIAL_STATE.userProfile
    };

    if(action.isGuest) {
        newState.guestUser = true;
    }

    return state.merge(newState);
};

const loginResponseMagicLink = (state, action) => {
    return state.merge({
        isMagicLinkUsed: action.magicLink.isMagicLinkUsed,
        isMagicLinkSuccess: action.magicLink.isMagicLinkSuccess,
        currentStudentId: action.magicLink.currentStudentId,
        magicLinkMeta: action.magicLink.magicLinkMeta
    })
}

const loginResponseInvitationLink = (state, action) => {
    return state.merge({
        isInvitationLinkUsed: action.result.isInvitationLinkUsed,
        isInvitationLinkSuccess: action.result.isInvitationLinkSuccess,
        isInvitationLinkFailed: action.result.isInvitationLinkFailed,
        invitationUserDetails: action.result.invitationUserDetails,
        invitationUserAssociations: action.result.invitationUserAssociations,
        invitationLink: action.result.invitationLink || [],
        showInvitationLinkModal: action.result.showInvitationLinkModal,
        allowInvitationLinkUpdate: action.result.allowInvitationLinkUpdate,
        invitationLinkUpdate: action.result.invitationLinkUpdate
    })
}

const changeMagicLinkStatus = (state, action) => {
    return state.merge({
        isMagicLinkUsed: false,
        isMagicLinkSuccess: false,
        isMagicLinkTCApplied: false,
        currentStudentId: null,
        isMagicLinkApplied: false,
        showMagicLinkDialog: false,
    })
}

const loginResponse = (state, action) => {
    if(action.response.ok && Boolean(action.response.profile)) {
        const profile = JSON.parse(action.response.profile);

        let custom = null;
        if(Boolean(action.response.custom)) {
            custom = JSON.parse(action.response.custom).json_value;
        }
        
        let data = null;
        if(Boolean(action.response.data)) {
            data = JSON.parse(action.response.data);
        }
        
        let userProfile = {
            fullName: String(profile.firstname + ' ' + (profile.lastname || '')).trim(),
            userId: profile.user_id,
            uuId: profile.uuid,
            profilePic: profile.profile_pic,
            email: profile.username,
            inEmail: (data && data.email && data.email.user_email) || '',
            dob: profile.dob || '',
            gender: profile.gender,
            phone: (data && data.phone && data.phone.user_phone_number) || '',
            address: (data && data.address && data.address.user_address_line_1) || '',
            city: (data && data.address && data.address.city) || '',
            pincode: (data && data.address && data.address.zip) || '',
            state: (data && data.address && data.address.state) || '',
            country: (data && data.address && data.address.country) || '',
            relationship: (custom && custom.child_relationship) || 'Father',
            data
        };

        userProfile = Object.assign({}, state.userProfile, userProfile);

        return state.merge({
            isAuthenticated: true,
            loginError: false,
            loginErrorCode: action.response.errorCode,
            loginMessage: action.response.message,
            isSignup: false,
            isLoading: false,
            userProfile,
            setPassword: action.response.setPassword,
            isMagicLinkApplied: action.response.isMagicLinkApplied
        });
    }        
    else
    {
        return state.merge({
            isAuthenticated: false,
            loginError: action.response.error,
            loginErrorCode: action.response.errorCode,
            loginMessage: action.response.message,
            isSignup: false,
            isLoading: false,
            isMagicLinkApplied: false
        });
    } 
};


const signupUser = (state, action) => {
    return state.merge({
        isAuthenticated: false,
        guestUser: false,
        error: false,
        errorCode: null,
        message: null,
        isSignup: true,
        isLoading: true,
        userProfile: INITIAL_STATE.userProfile
    });
};

const signupUserV2 = (state, action) => {
    return state.merge({
        isAuthenticated: false,
        guestUser: false,
        error: false,
        errorCode: null,
        message: null,
        isSignup: true,
        isLoading: true,
        userProfile: INITIAL_STATE.userProfile
    });
};

const signupUserV2_1 = (state, action) => {
    return state.merge({
        isAuthenticated: false,
        guestUser: false,
        error: false,
        errorCode: null,
        message: null,
        isSignup: true,
        isLoading: true,
        userProfile: INITIAL_STATE.userProfile
    });
};

const postParentLinkedIn = (state, action) => {
    return state.merge({
        isLoading: true
    })
}

const signupResponse = (state, action) => {
    if(action.response.ok) {
        const profile = JSON.parse(action.response.profile);

        let custom = null;
        if(Boolean(action.response.custom)) {
            custom = JSON.parse(action.response.custom).json_value;
        }
        
        let data = null;
        if(Boolean(action.response.data)) {
            data = typeof action.response.data === 'string' ? JSON.parse(action.response.data) : action.response.data
        }

        let userProfile = {
            fullName: String(profile.firstname + ' ' + (profile.lastname || '')).trim(),
            userId: profile.user_id,
            uuId: profile.uuid,
            profilePic: profile.profile_pic,
            email: profile.username,
            dob: profile.dob || '',
            gender: profile.gender,
            inEmail: (data && data.email && data.email.user_email) || '',
            phone: (data && data.phone && data.phone.user_phone_number) || '',
            address: (data && data.address && data.address.user_address_line_1) || '',
            city: (data && data.address && data.address.city) || '',
            pincode: (data && data.address && data.address.zip) || '',
            state: (data && data.address && data.address.state) || '',
            country: (data && data.address && data.address.country) || '',
            relationship: (custom && custom.child_relationship) || 'Father',
            data
        };

        userProfile = Object.assign({}, state.userProfile, userProfile);

        return state.merge({
            isAuthenticated: true,
            error: false,
            errorCode: null,
            message: action.response.message,
            isSignup: true,
            isLoading: false,
            userProfile
        });
    }

    else return state.merge({
        isAuthenticated: false,
        error: action.response.error,
        errorCode: action.response.errorCode,
        message: action.response.message,
        isSignup: true,
        isLoading: false
    });
};


const updateUser = (state, action) => {
    if(!Boolean(action.next) || !Boolean(action.next.action)) {
        return state.merge({
            isUpdating: true,
            updateStatus: false,
            updateError: ''
        });
    }

    const type = action.next.action({}).type;

    if(type === Types.RESPONSE_UPDATE_USER) {
        return state.merge({
            isUpdating: true,
            updateStatus: false,
            updateError: ''
        });
    }

    else {
        return state;
    }
};


const updateResponse = (state, action) => {
    if(Boolean(action.response) && action.response.status) {
        return state.merge({
            isUpdating: false,
            updateStatus: true,
            updateError: ''
        });
    }
    
    return state.merge({
        isUpdating: false,
        updateStatus: false,
        updateError: action.response.error
    });
};


const getUser = (state, action) => {
    return state.merge({
        // isLoading: true
    });
};



const responseVerifyEmail = (state, action) => {
    return state.merge({
        emailVerified: true,
        emailStatus: action.response.status
    });
};


const responseVerifyPhone = (state, action) => {
    return state.merge({
        phoneVerified: true,
        phoneStatus: action.response.status
    });
};

// Method is for Checking availabilty Of email,phone,activaitoncode without DOB --- as per New Requirment 


const responseCheckEmailAvailability = (state, action) => {
    return state.merge({
        emailVerified: true,
        ckeckEmailStatus: action.response.status,
        checkValidationResponseType:'email',
    });
};

const responseCheckPhoneNumberAvailability = (state, action) => {
    return state.merge({
        phoneVerified: true,
        checkPhoneStatus: action.response.status,
        checkValidationResponseType:'phone',
        checkPhoneStatusMeta: action.response.meta
    });
};

const responseCheckActivationCodeAvailability = (state, action) => {
    return state.merge({
        activationVerified: true,
        activationInProgress: true,
        checkActivationStatus: action.response.status,
        checkValidationResponseType:'activation',
    });
};

const checkActivationCodeAvailability = (state, action) => {
    return state.merge({
        activationVerified: false,
        checkActivationStatus: false,
        activationInProgress: false,
        checkValidationResponseType:'',
    });
};

const responseChangeValidationResponseType = (state, action) => {
    return state.merge({
        checkValidationResponseType:action.response
    });
};

const storeUserSignUpStatus = (state, action) => {
    return state.merge({
        userSignUpStatus:action.response.status
    });
};

const parentUpdateResponse = (state, action) => {
    return state.merge({
        userProfile: { ...state.userProfile, ...action.response }
    });
};
const setHSGBannerFlag = (state, action) => {
    return state.merge({
        HSGBannerFlag: action.flag
    })
}

const setLoader = state => {
    return state.merge({
        isComponentLoading: true
    });
};

const unsetLoader = state => {
    return state.merge({
        isComponentLoading: false
    });
};

const setSidebar = state => {
    return state.merge({
        showSideBar: true
    });
};

const unsetSidebar = state => {
    return state.merge({
        showSideBar: false
    });
};

const changeUserProfileModalState = (state, action) => {
    return state.merge({
        openUserProfile: action.flag,
        modalType:action.modalType
    });
  };

const ACTION_HANDLERS = {

    [Types.CHANGE_MAGIC_LINK_STATUS]: changeMagicLinkStatus,

    [Types.LOGIN_USER]: loginUser,
    [Types.LOGIN_RESPONSE]: loginResponse,
    [Types.LOGIN_RESPONSE_MAGIC_LINK]: loginResponseMagicLink,
    [Types.LOGIN_RESPONSE_INVITATION_LINK]: loginResponseInvitationLink,

    [Types.SIGNUP_USER]: signupUser,
    [Types.SIGNUP_USER_V2]: signupUserV2,
    [Types.SIGNUP_USER_V2_1]: signupUserV2_1,
    [Types.SIGNUP_RESPONSE]: signupResponse,

    [Types.UPDATE_USER]: updateUser,
    [Types.RESPONSE_UPDATE_USER]: updateResponse,

    [Types.GET_USER]: getUser,

    [Types.RESPONSE_AVAILABILITY_EMAIL]: responseVerifyEmail,
    [Types.RESPONSE_AVAILABILITY_PHONE]: responseVerifyPhone,

    [Types.RESPONSE_CHECK_EMAIL_AVAILABILITY]: responseCheckEmailAvailability,
    [Types.RESPONSE_CHECK_PHONE_NUMBER_AVAILABILITY]: responseCheckPhoneNumberAvailability,
    [Types.RESPONSE_CHECK_ACTIVATION_CODE_AVAILABILITY]: responseCheckActivationCodeAvailability,
    [Types.CHECK_ACTIVATION_CODE_AVAILABILITY]: checkActivationCodeAvailability,
    [Types.RESPONSE_CHANGE_VALIDATION_RESPONSE_TYPE]: responseChangeValidationResponseType,

    [Types.STORE_USER_SIGNUP_STATUS]: storeUserSignUpStatus,
    [Types.PARENT_UPDATE_RESPONSE]: parentUpdateResponse,
    [Types.POST_PARENT_LINKED_IN]: postParentLinkedIn,

    [Types.SET_HSG_BANNER_FLAG]: setHSGBannerFlag,

    [Types.SET_LOADER]: setLoader,
    [Types.UNSET_LOADER]: unsetLoader,

    [Types.SHOW_SIDEBAR]: setSidebar,
    [Types.HIDE_SIDEBAR]: unsetSidebar,


    [Types.CHANGE_USER_PROFILE_MODAL_STATE]: changeUserProfileModalState

};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)